import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const QuiltPlannerFooter = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: { xs: 2, sm: 3 },
        backgroundColor: 'primary.light',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: 'center',
          justifyContent: { xs: 'center', md: 'space-between' },
          gap: { xs: 1, md: 0 },
          textAlign: { xs: 'center', md: 'left' },
        }}
      >
        {/* Left side - Designer and Built with Lovable */}
        <Typography
          variant="caption"
          sx={{
            fontSize: '14px',
            color: 'text.secondary',
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 1,
            justifyContent: { xs: 'center', md: 'flex-start' },
          }}
        >
          Designed by{' '}
          <Link
            href="https://emily-gilles.com/"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Emily Gilles
            <OpenInNewIcon sx={{ fontSize: 14 }} aria-hidden="true" focusable="false" />
          </Link>
          {' · '}
          Built with Lovable
        </Typography>
        
        {/* Right side - Tutorials and Give feedback */}
        <Typography
          variant="caption"
          sx={{
            fontSize: '14px',
            color: 'text.secondary',
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'center', md: 'flex-end' },
            gap: 1,
          }}
        >
          <Link
            href="/tutorials"
            sx={{
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
          >
            Tutorials
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};